import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Instagram, Clock } from 'lucide-react';
import { siteConfig, neighborhoods, services } from '../data/mock';
import { WhatsAppButton } from './WhatsAppButton';

export const Footer = () => {
  return (
    <footer className="bg-black text-gray-300 pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 pb-8 border-b border-gray-800">
          {/* Sobre */}
          <div>
            <img 
              src={siteConfig.logo} 
              alt="Box7go" 
              className="h-12 mb-4"
            />
            <p className="text-sm mb-4">
              {siteConfig.tagline}
            </p>
            <p className="text-sm text-gray-400 mb-4">
              Estética automotiva e lava jato premium em Goiânia e Aparecida de Goiânia.
            </p>
            <WhatsAppButton text="Fale Conosco" className="text-sm" />
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Serviços</h3>
            <ul className="space-y-2 text-sm">
              {services.slice(0, 6).map((service) => (
                <li key={service.slug}>
                  <Link 
                    to={`/${service.slug}`}
                    className="hover:text-[#00B4D8] transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link 
                  to="/estetica-automotiva"
                  className="hover:text-[#00B4D8] transition-colors"
                >
                  Estética Automotiva
                </Link>
              </li>
            </ul>
          </div>

          {/* Localização */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Regiões Atendidas</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/lava-jato-goiania"
                  className="hover:text-[#00B4D8] transition-colors"
                >
                  Lava Jato Goiânia
                </Link>
              </li>
              <li>
                <Link 
                  to="/lava-jato-aparecida-de-goiania"
                  className="hover:text-[#00B4D8] transition-colors"
                >
                  Lava Jato Aparecida de Goiânia
                </Link>
              </li>
              <li>
                <Link 
                  to="/lava-jato-perto-de-mim"
                  className="hover:text-[#00B4D8] transition-colors"
                >
                  Lava Jato Perto de Mim
                </Link>
              </li>
              {neighborhoods.slice(0, 4).map((neighborhood) => (
                <li key={neighborhood}>
                  <span className="text-gray-400">{neighborhood}</span>
                </li>
              ))}
              <li>
                <span className="text-gray-400">+ outros 14 bairros</span>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contato</h3>
            <div className="space-y-3 text-sm">
              <a 
                href={`tel:+${siteConfig.phone}`}
                className="flex items-start gap-2 hover:text-[#00B4D8] transition-colors"
              >
                <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>(62) 98241-6008</span>
              </a>
              <a 
                href={siteConfig.googleMaps}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 hover:text-[#00B4D8] transition-colors"
              >
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>Jardim Bela Vista<br />Goiânia - GO</span>
              </a>
              <a 
                href={siteConfig.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 hover:text-[#00B4D8] transition-colors"
              >
                <Instagram className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>@box7.go</span>
              </a>
              <div className="flex items-start gap-2">
                <Clock className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>Seg - Sex: 8h - 18h<br />Sáb: 8h - 17h</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 text-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} Box7go Estética e Lava Jato. Todos os direitos reservados.</p>
          <p className="mt-2">
            Lava jato e estética automotiva em Goiânia e Aparecida de Goiânia - GO
          </p>
        </div>
      </div>
    </footer>
  );
};
